<template>
  <DropDownMenu
    :disabled="disabled"
    :menuSections="menuSections"
    menuTitle="actions"
  />
</template>

<script>
import { extend, values } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import Constants, { ApplePackageManagers, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import DropDownMenu from 'client/components/DropDownMenu/DropDownMenu.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import pluralize from 'pluralize';

const { error, success } = Constants;

export default {
  name: 'RenewDeleteDropDown',

  components: {
    DropDownMenu,
  },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    itemType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return values(ItemTypeConsts).indexOf(value) !== -1;
      },
    },
    tokenId: {
      required: true,
      type: [Number, String],
    },
  },

  computed: {
    menuSections() {
      return [{
        menuItems: [
          { label: 'Renew Configuration', action: () => this.renewConfig(this.tokenId) },
          { label: 'Delete Configuration', action: () => this.deleteConfig(this.tokenId) },
        ],
      }];
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;
    const storeModule = StoreModuleMap[itemType];
    const softwareAppsModule = StoreModuleMap[ItemTypeConsts.softwareApps];

    extend(
      this.$options.methods,
      mapActions(storeModule, ['deleteSToken']),
      mapActions(softwareAppsModule, [
        'fetchCollection',
        'setFilters',
      ]),
    );

    extend(
      this.$options.computed,
      mapGetters(softwareAppsModule, ['getTotalCount']),
    );
  },

  methods: {
    async deleteConfig(tokenId) {
      const appleVppFilter = {
        name: 'packageManager',
        operator: 'eq',
        value: ApplePackageManagers.appleVpp,
      };
      const locationObjectIdFilter = {
        name: 'locationObjectId',
        operator: 'eq',
        value: tokenId,
      };

      this.setFilters({ filtersArray: [appleVppFilter, locationObjectIdFilter] });

      await this.fetchCollection();

      const appCountText = `${this.getTotalCount} ${pluralize('app', this.getTotalCount)}`;

      ModalEventBus.open({
        component: 'ConfirmationModal',
        componentProps: {
          cancelText: 'cancel',
          continueText: 'delete',
          headerText: 'Delete Token',
          mdTemplate: `**Are you sure** you want to delete the VPP token from JumpCloud? This action removes the token's connection to JumpCloud but does not delete the token from Apple Business Manager. Deleting the token also removes the licenses for ${appCountText}.`,
          handleContinue: () => this.handleDeleteToken(tokenId),
          mainActionAttention: true,
        },
      });
    },

    handleDeleteToken(tokenId) {
      this.deleteSToken(tokenId)
        .then(() => {
          notify(success, 'VPP Token successfully deleted.');
        })
        .catch(() => {
          notify(error, 'VPP Token could not be deleted.');
        })
        .finally(() => {
          ModalEventBus.close();
        });
    },

    renewConfig(tokenId) {
      this.$emit('renewVppToken', tokenId);
    },
  },
};
</script>
